import StarterKit from '@tiptap/starter-kit';
import { mention } from "./mention/mention";
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import Heading from "@tiptap/extension-heading";
import TextAlign from '@tiptap/extension-text-align';
import SlashCommands from "./slash-command/command";
import suggestion from "./slash-command/suggestion";
import CustomTable from "./custom-table/custom-table";
import CustomTableRow from "./custom-table/custom-table-row";
import CustomTableCell from "./custom-table/custom-table-cell";
import CustomTableHeaderCell from "./custom-table/custom-table-header-cell";
import Highlight from '@tiptap/extension-highlight'
import { TextStyleKit } from '@tiptap/extension-text-style';
import Superscript from '@tiptap/extension-superscript';
import Subscript from '@tiptap/extension-subscript';
import Strike from '@tiptap/extension-strike'
import { InternalLinking } from './custom-extentions/link';
import { pasteOnlySystemFonts, SYSTEM_FONTS } from './custom-extentions/pasteOnlySystemFonts';
const CustomDocument = Document.extend({
  content: 'block*',  // allow empty or table-only content
})

const Extentions = [
        StarterKit.configure({
            heading : false,
            text: false,
            paragraph: false,
            document: false,
            link: false,
            trailingNode: false,
        }),
        mention,
        CustomDocument,
        Paragraph,
        Text,
        Heading.configure({
            levels: [1, 2, 3, 4, 5, 6],
        }),
        TextStyleKit.configure({
            backgroundColor: {
                types: ['textStyle'],
            },
            color: {
                types: ['textStyle'],
            },
            fontFamily: {
                types: ['textStyle'],
            },
            fontSize: {
                types: ['textStyle'],
            },
            lineHeight: {
                types: ['textStyle'],
            },
        }),
        TextAlign.configure({
            alignments: ['left', 'center', 'right', 'justify'],
            types: ['heading', 'paragraph']
        }),
        InternalLinking.configure({
            openOnClick: true,
            autolink: true,
            defaultProtocol: 'https',
        }),
        SlashCommands.configure({
            suggestion,
        }),
        CustomTableRow,
        CustomTableHeaderCell,
        CustomTableCell,
        CustomTable,
        Highlight.configure({ multicolor: true }),
        // LineHeight.configure({
        //     types: ['textStyle']
        // }),
        Strike,
        Subscript,
        Superscript,
        pasteOnlySystemFonts.configure({
            allowedFamilies: SYSTEM_FONTS
        })
];

export default Extentions;